// Inlined at build time by Vite via import.meta.env.
// Unset (local dev / no build arg) → registration is enabled (backward compatible).
// Set to "false" via docker build --build-arg REGISTRATION_ENABLED=false → registration disabled.
export const REGISTRATION_ENABLED =
  import.meta.env.VITE_REGISTRATION_ENABLED !== 'false';